function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#adc6ca",
  fillRule: "evenodd",
  d: "M7.486 14.398C3.702 8.912 3 8.349 3 6.333a5 5 0 0110 0c0 2.016-.702 2.58-4.486 8.065a.626.626 0 01-1.028 0zM8 8.417a2.084 2.084 0 10-.001-4.167A2.084 2.084 0 008 8.417z"
});

function SvgAddressinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _ref);
}

export default SvgAddressinline;